import { SVGProps } from 'react';

const RussianRuble = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 11h8a4 4 0 1 0 0-8H9v18m-3-6h8"
    />
  </svg>
);
export default RussianRuble;
